import { computed, ref } from 'vue-demi';
import { to } from '@tencent/wphk-base-utils';
import { CustomException } from '@tencent/ppd-base-libs';
import { getMallThemeInfoList } from '../business/index';
import { MallThemeInfo } from '../type';

const isInited = ref(false);
const currMallId = ref('');
const mallThemeInfos = ref<MallThemeInfo[]>([]);
const isUserClicked = ref(false);

export function useMall() {
  const isHasMallData = computed(() => mallThemeInfos.value.length > 0);

  /** 当前选中的商圈专题信息 */
  const currMallthemeInfo = computed(() => mallThemeInfos.value.find(item => item.mallInfo.id === currMallId.value));

  /** 当前选中的商圈信息 */
  const currMallInfo = computed(() => currMallthemeInfo.value?.mallInfo);

  /** 当前商户下广告信息 */
  const currAdInfo = computed(() => currMallthemeInfo.value?.adInfo);

  /** 当前商户下广告信息 */
  const currDpInfo = computed(() => currMallthemeInfo.value?.dpInfo);

  /**
   * 设置当前的商户ID
   * @param spid 商户ID
   */
  function setCurrSpid(spid: string) {
    currMallId.value = spid;
  }

  function setUserClicked() {
    isUserClicked.value = true;
  }

  /** 初始化商圈数据 */
  async function init() {
    const [err, list] = await to(getMallThemeInfoList());
    if (err) {
      new CustomException(err, 'getMallInfoListErr', '获取商圈信息失败');
    }
    if (list) {
      mallThemeInfos.value = list;
    }
    isInited.value = true;
  }

  return {
    isInited,
    isHasMallData,
    mallThemeInfos,
    currMallInfo,
    currAdInfo,
    currDpInfo,
    isUserClicked,
    setUserClicked,
    init,
    setCurrSpid,
  };
}
